export interface ISearchItem {
  name: string
  code: string
  slug: string
}

export class SearchItem implements ISearchItem {
  constructor(
    public name: string = '',
    public code: string = '',
    public slug: string = ''
  ) {}
}

export default SearchItem 